import { normalizeSearchText } from '@modules/global/utils/global-search/search-index'
import { formatBrokerCode } from '@utils/cliente-codigo/cliente-codigo'

// Índice normalizado por LISTA, não por tecla.
//
// `normalizeSearchText` faz `normalize('NFD')` + regex; rodar isso por cliente a
// cada tecla, sobre uma base de milhares, é o custo real do filtro (o
// `global-search/client-search.js` documenta o mesmo cuidado). O `WeakMap` é
// chaveado pela REFERÊNCIA da lista: `user/allClients` e o getter dos recentes
// só produzem array novo quando os dados mudam, então o índice é construído uma
// vez por carga e reusado em toda a digitação. Lista descartada some do mapa
// sozinha.
const indicePorLista = new WeakMap()

const indexar = (list) => {
  const pronto = indicePorLista.get(list)
  if (pronto) return pronto
  const index = list.map((client) => ({
    client,
    name: normalizeSearchText(client.name),
    code: normalizeSearchText(formatBrokerCode(client.codigo_corretora)),
  }))
  indicePorLista.set(list, index)
  return index
}

/**
 * Filtra clientes por nome ou código da corretora, ignorando acento e caixa.
 *
 * O código passa pelo MESMO `formatBrokerCode` que monta o subtítulo: sem isso o
 * componente diz duas coisas sobre o mesmo valor — esconde `'None'` sob o nome
 * do cliente e o encontra pelo dropdown (465 clientes em produção).
 *
 * O `id` interno NÃO é buscável de propósito: ele não aparece em tela nenhuma
 * do produto, enquanto o código da corretora é o identificador que o assessor
 * já usa (cadastro do cliente, CRM, header do Consolidador). É a convenção da
 * busca global — `@modules/global/utils/global-search/client-search` casa nome,
 * e-mail e `codigo_corretora`, sem id. Aqui o e-mail fica de fora: o switcher
 * lista clientes por nome, e quem procura por e-mail usa a busca global.
 *
 * Busca vazia retorna a lista inteira.
 * @param {Array} list  clientes ({ id, name, codigo_corretora })
 * @param {string} query
 * @returns {Array}
 */
export function filterClients(list, query) {
  const q = normalizeSearchText(query)
  if (!q) return list
  return indexar(list)
    .filter((entrada) => entrada.name.includes(q) || entrada.code.includes(q))
    .map((entrada) => entrada.client)
}

/**
 * Resolve os clientes recentes (ids) para objetos completos, preservando ordem
 * e descartando ids que não existem mais na lista.
 * @param {Array<number>} recentIds
 * @param {Array} allClients
 * @returns {Array}
 */
export function resolveRecents(recentIds, allClients) {
  return (recentIds || [])
    .map((id) => allClients.find((c) => c.id === id))
    .filter(Boolean)
}
